import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class WillAdditionalNeedQuebecType extends Enum {
  key!: string;
  value!: string;
  description!: string;

  static RETURN_OF_GIFTS: WillAdditionalNeedQuebecType = {
    key: 'return_of_gifts',
    get value(): string {
      return Lang.t('will.return-of-gifts');
    },
    get description(): string {
      return Lang.t('will.return-of-gifts-description');
    }
  };

  static LEGACY_SUBJECT_TO_TAKING_CARE_OF_YOUR_PET: WillAdditionalNeedQuebecType = {
    key: 'legacy_subject_to_taking_care_of_your_pet',
    get value(): string {
      return Lang.t('will.care-of-your-pet');
    },
    get description(): string {
      return Lang.t('will.care-of-your-pet-description');
    }
  };

  static PET_TRUST: WillAdditionalNeedQuebecType = {
    key: 'pet_trust',
    get value(): string {
      return Lang.t('will.pet-trust');
    },
    get description(): string {
      return Lang.t('will.pet-trust-description');
    }
  };

  static CONDITIONAL_LEGACY: WillAdditionalNeedQuebecType = {
    key: 'conditional_legacy',
    get value(): string {
      return Lang.t('will.conditional-legacy');
    },
    get description(): string {
      return Lang.t('will.conditional-legacy-description');
    }
  };

  static SHARE_LEGACY_CONDITIONAL_UPON_THE_RESPECT_OF_A_SHAREHOLDER_AGREEMENT: WillAdditionalNeedQuebecType =
    {
      key: 'share_legacy_conditional_upon_the_respect_of_a_shareholder_agreement',
      get value(): string {
        return Lang.t('will.share-legacy-conditional');
      },
      get description(): string {
        return Lang.t('will.share-legacy-conditional-description');
      }
    };

  static REFERENCE_TO_A_SHAREHOLDER_AGREEMENT: WillAdditionalNeedQuebecType = {
    key: 'reference_to_a_shareholder_agreement',
    get value(): string {
      return Lang.t('will.reference-shareholder-agreement');
    },
    get description(): string {
      return Lang.t('will.reference-shareholder-agreement-description');
    }
  };

  static HENSON_TRUST: WillAdditionalNeedQuebecType = {
    key: 'henson_trust',
    get value(): string {
      return Lang.t('will.henson-trust');
    },
    get description(): string {
      return Lang.t('will.henson-trust-description');
    }
  };

  static TESTAMENTARY_TRUST: WillAdditionalNeedQuebecType = {
    key: 'testamentary_trust',
    get value(): string {
      return Lang.t('will.testamentary-trust');
    },
    get description(): string {
      return Lang.t('will.testamentary-trust-description');
    }
  };

  static OTHER: WillAdditionalNeedQuebecType = {
    key: 'other',
    get value(): string {
      return Lang.t('will.other');
    },
    get description(): string {
      return Lang.t('will.you-be-specify');
    }
  };
}
